import { render, staticRenderFns } from "./Avanzamento.vue?vue&type=template&id=156ead98&scoped=true&"
import script from "./Avanzamento.vue?vue&type=script&lang=js&"
export * from "./Avanzamento.vue?vue&type=script&lang=js&"
import style0 from "./Avanzamento.vue?vue&type=style&index=0&id=156ead98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ead98",
  null
  
)

export default component.exports